export default __webpack_public_path__ + "static/media/gallery-wip-3d-model_02.217ac51d.jpg";